<template>
  <div class="selection" @mouseleave="delayedPackUp" ref="selection">
    <div class="filter" :class="className">
      <!-- <TreeSelect
        v-if="type === 1"
        class="treeSelect"
        :placeholder="$t('selection.selectMajor')"
        :defaultValue="professionList"
        @handleCheckboxChange="handleCheckboxChange"
      /> -->
      <a-input-search
        allowClear
        v-model="selected.keyword"
        :placeholder="$t('selection.enterResourceName')"
        @change="onSearch"
      >
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img
          class="clear"
          v-if="selected.keyword"
          slot="suffix"
          @click=";(selected.keyword = undefined), onSearch()"
          :src="require('@/assets/icons/icon_gb.png')"
        />
        <a-button class="search-btn" slot="enterButton">
          {{ $t('selection.search') }}
        </a-button>
      </a-input-search>
    </div>
    <div v-if="type !== 2" class="filter between">
      <div class="resourceType">
        <div class="label">{{ $t('selection.resourceType') }}：</div>
        <div class="list" v-for="item in resourceTypeList" :key="item.value">
          <span :class="selected.resType === item.value ? 'selected' : ''" @click="typeChange(item.value)">{{
            item.label
          }}</span>
        </div>
      </div>
      <div class="auth" v-if="type === 1">
        <span class="label">{{ $t('selection.showAuthResources') }}：</span>
        <a-switch v-model="selected.isAuth" @change="onChange" />
      </div>
    </div>
    <div class="major-tree">
      <div class="filter between ">
        <div class="resourceType"  v-if="selected.resType === 'software'">
          <div class="label">{{ $t('selection.classificationMethod') }}：</div>
          <div class="list">
            <span @click="changecClassType('major')" :class="classType === 'major' ? 'selected' : ''">{{
              $t('selection.majorClassification')
            }}</span>
          </div>
          <div class="list">
            <span @click="changecClassType('industry')" :class="classType === 'industry' ? 'selected' : ''">{{
              $t('selection.industryClassification')
            }}</span>
          </div>
        </div>
        <div class="resourceType" v-else>
          <div class="label">{{ $t('selection.teachingLevel') }}：</div>
          <div class="list" v-for="item in majorTreeData" :key="item.id">
            <span
              :class="selected.V1 === item.id ? 'selected' : ''"
              @click="majorChange(item.id, 'V1', item.children)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div class="unfold" @click="unfold" v-show="isPackUp && (selected.V1 || selected.resType === 'software')">
          {{ $t('selection.expand') }}
          <a-icon type="down" style="color: #767D95; font-size: 10px; margin-top: 2px; margin-left: 2px" />
        </div>
      </div>
      <div class="majorSelector" ref="majorSelector">
        <div class="filter between " v-show="selected.resType === 'software'">
          <div class="resourceType">
            <div class="label">{{ $t('selection.compatibleDevice') }}：</div>
            <div class="group-list">
              <div class="list" v-for="item in machineList" :key="item.id">
                <span :class="selected.deviceId === item.id ? 'selected' : ''" @click="deviceChange(item)">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="filter between " v-show="classType === 'major' && selected.resType === 'software'" style="margin-top: -5px">
          <div class="resourceType">
            <div class="label">{{ $t('selection.teachingLevel') }}：</div>
            <div class="list" v-for="item in majorTreeData" :key="item.id">
              <span
                :class="selected.V1 === item.id ? 'selected' : ''"
                @click="majorChange(item.id, 'V1', item.children)"
                >{{ item.name }}</span
              >
            </div>
          </div>
        </div>
        <template v-if="classType === 'major' && (majorClassList.length > 0 || majorList.length > 0)">
          <div class="filter between " v-show="majorClassList.length > 0">
            <div class="resourceType">
              <div class="label">{{ $t('selection.majorCategory') }}：</div>
              <div class="group-list">
                <div class="list" v-for="item in majorClassList" :key="item.id">
                  <span
                    :class="selected.V2 === item.id ? 'selected' : ''"
                    @click="majorChange(item.id, 'V2', item.sub)"
                    >{{ item.name }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="filter between " style="margin-top: -6px;" v-show="majorList.length > 0">
            <div class="resourceType">
              <div class="label">{{ $t('selection.major') }}：</div>
              <div class="list" v-for="item in majorList" :key="item.id">
                <span :class="selected.V3 === item.id ? 'selected' : ''" @click="majorChange(item.id, 'V3')">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
        </template>
        <div class="filter between " style="margin-top: -6px;" v-show="industryData.length > 0 && classType === 'industry'">
          <div class="resourceType">
            <div class="label">{{ $t('selection.industryClassification') }}：</div>
            <div class="group-list">
              <div class="list" v-for="item in industryData" :key="item.id">
                <span :class="selected.industryId === item.id ? 'selected' : ''" @click="industryChange(item)">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="filter between "
          style="margin-top: -6px;"
          v-show="regionData.length > 0 && classType === 'industry' && selected.needArea"
        >
          <div class="resourceType">
            <div class="label">{{ $t('selection.selectRegion') }}：</div>
            <div class="group-list">
              <div class="list" v-for="item in regionData" :key="item.id">
                <span :class="selected.V4 === item.id ? 'selected' : ''" @click="majorChange(item.id, 'V4')">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="filter between "
          style="margin-top: -8px;"
          v-show="starData.length > 0 && classType === 'industry' && selected.needStar"
        >
          <div class="resourceType">
            <div class="label">{{ $t('selection.selectStarLevel') }}：</div>
            <div class="list" v-for="item in starData" :key="item.id">
              <span :class="selected.V6 === item.id ? 'selected' : ''" @click="majorChange(item.id, 'V6')">{{
                item.name
              }}</span>
            </div>
          </div>
        </div>
        <div class="pack-up" @click="packUp" v-show="!isPackUp">
          {{ $t('selection.collapse') }}
          <a-icon type="up" style="color: #767D95; font-size: 10px; margin-top: 2px; margin-left: 2px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { industryList, regionList, starList, machineList } from '@/api/lesson'
import TreeSelect from '@/components/treeSelect/index2.vue'

export default {
  components: {
    TreeSelect
  },
  props: {
    className: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      type: 1,
      selected: {
        resType: '',
        isAuth: false,
        profession: [],
        industryId: '',
        deviceId: '',
        industryAttr: [],
        keyword: undefined,
        needArea: false,
        needStar: false,
        V1: '',
        V2: '',
        V3: '',
        V4: '', // 省份
        V6: '' // 星级
      },
      classType: 'major',
      resourceTypeList: [],
      majorTreeData: [],
      majorClassList: [],
      majorList: [],
      industryData: [],
      regionData: [],
      starData: [],
      isPackUp: true,
      machineList: []
    }
  },
  mounted() {
    this.getResTypeMap()
    this.getIndustryList()
    this.getMajorTreeData()
    this.getMachineList()
    // 获取当前语言类型
    const currentLocale = this.$i18n.locale
    console.log('语言类型 ----->', currentLocale)
    if (currentLocale === 'en-US') {
      this.setEnglishLabelStyle()
    }
    // this.$nextTick(() => {
    //   this.packUp()
    // })
  },
  methods: {
    getMajorTreeData() {
      this.majorTreeData = JSON.parse(localStorage.treeList)
      this.majorTreeData.unshift({
        id: '',
        name: this.$t('selection.all')
      })
      console.log('majorTreeData', this.majorTreeData)
    },
    handleTypeChange(key) {
      this.type = key
      this.selected = {
        resType: '',
        isAuth: false,
        profession: [],
        industryAttr: [],
        keyword: undefined
      }
      this.$emit('handleChange', this.selected)
    },
    onChange() {
      this.$emit('handleChange', this.selected)
    },
    onSearch() {
      this.selected.resType = ''
      this.$emit('handleChange', this.selected)
    },
    handleCheckboxChange(el) {
      this.selected.resType = ''
      const list = []
      el.forEach(item => {
        const obj = {
          V1: item.V1 ? Number(item.V1) : undefined,
          V2: item.V2 ? Number(item.V2) : undefined,
          V3: item.V3 ? Number(item.V3) : undefined
        }
        list.push(obj)
      })
      this.selected = Object.assign(this.selected, {
        profession: [...list]
      })
      this.$emit('handleChange', this.selected)
    },
    typeChange(id) {
      this.selected.resType = id
      this.classType = 'major'
      this.isPackUp = true
      this.selected.V1 = ''
      this.selected.V2 = ''
      this.selected.V3 = ''
      this.selected.V4 = ''
      this.selected.V6 = ''
      this.majorClassList = []
      this.majorList = []
      this.selected.profession = [] // 清空专业分类
      this.selected.industryId = ''
      this.selected.deviceId = ''
      this.selected.industryAttr = [] // 清空行业分类
      this.selected.needArea = false
      this.selected.needStar = false
      if (id === 'software') {
        this.unfold()
      }
      this.$emit('handleChange', this.selected)
    },
    getResTypeMap() {
      this.resourceTypeList = [
        {
          label: this.$t('personal.resource.all'),
          value: '',
          checked: true
        },
        {
          label: this.$t('personal.resource.resourceType.model'),
          value: 'model',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.software'),
          value: 'software',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.text'),
          value: 'text',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.image'),
          value: 'image',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.video'),
          value: 'video',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.audio'),
          value: 'audio',
          checked: false
        }
      ]
    },
    majorChange(id, type, children) {
      this.selected[type] = id

      if (type === 'V1') {
        if (children) {
          this.majorClassList = JSON.parse(JSON.stringify(children))
          this.majorClassList.unshift({
            id: '',
            name: this.$t('selection.all')
          })
          this.majorList = []
        } else {
          this.majorClassList = []
          this.majorList = []
        }
        this.selected.V2 = ''
        this.selected.V3 = ''
        this.unfold()
      } else if (type === 'V2') {
        if (children) {
          this.majorList = JSON.parse(JSON.stringify(children))
          this.majorList.unshift({
            id: '',
            name: this.$t('selection.all')
          })
        } else {
          this.majorList = []
        }
        this.selected.V3 = ''
      }
      if (!this.selected.V1) {
        this.selected.profession = []
      }
      const majorObj = {
        V1: this.selected.V1 ? Number(this.selected.V1) : undefined,
        V2: this.selected.V2 ? Number(this.selected.V2) : undefined,
        V3: this.selected.V3 ? Number(this.selected.V3) : undefined
      }
      // 过滤掉值为undefined的项
      const filteredMajorObj = Object.fromEntries(Object.entries(majorObj).filter(([_, value]) => value !== undefined))
      if (Object.keys(filteredMajorObj).length > 0) {
        this.selected.profession = [filteredMajorObj]
      } else {
        this.selected.profession = []
      }

      // 如果是行业分类
      const industryObj = {
        V4: this.selected.V4 ? Number(this.selected.V4) : undefined,
        V6: this.selected.V6 ? String(this.selected.V6) : undefined
      }
      // 过滤掉值为undefined的项
      const filteredindustryObj = Object.fromEntries(
        Object.entries(industryObj).filter(([_, value]) => value !== undefined)
      )
      if (Object.keys(filteredindustryObj).length > 0) {
        this.selected.industryAttr = [filteredindustryObj]
      } else {
        this.selected.industryAttr = []
      }

      this.$emit('handleChange', this.selected)
      console.log('selected', this.selected)
    },
    packUp() {
      const majorSelector = this.$refs.majorSelector
      majorSelector.style.maxHeight = '0px'
      majorSelector.style.paddingBottom = '0px'
      this.isPackUp = true
    },
    unfold() {
      const majorSelector = this.$refs.majorSelector
      majorSelector.style.maxHeight = '550px' // 设置一个足够大的值
      majorSelector.style.paddingBottom = '30px'
      this.isPackUp = false
    },
    delayedPackUp() {
      setTimeout(this.packUp, 500)
    },
    getIndustryList() {
      industryList().then(res => {
        if (res.code === 200) {
          this.industryData = res.data.list
          this.industryData.unshift({
            id: '',
            name: this.$t('selection.all')
          })
        }
        console.log('res', res)
      })
      regionList().then(res => {
        if (res.code === 200) {
          this.regionData = res.data.list
          this.regionData.unshift({
            id: '',
            name: this.$t('selection.all')
          })
        }
      })
      starList().then(res => {
        if (res.code === 200) {
          this.starData = res.data.list
          this.starData.unshift({
            id: '',
            name: this.$t('selection.all')
          })
        }
      })
    },
    industryChange(industry) {
      console.log('industry', industry)
      this.selected.V4 = ''
      this.selected.V6 = ''
      this.selected.industryAttr = []
      if (industry.id === '') {
        this.selected.industryId = ''
        this.selected.needArea = false
        this.selected.needStar = false
        this.$emit('handleChange', this.selected)
        return
      }
      this.selected.industryId = industry.id
      this.selected.needArea = industry.needArea === '1'
      this.selected.needStar = industry.needStar === '1'
      this.$emit('handleChange', this.selected)
    },
    deviceChange(device) {
      this.selected.deviceId = device.id
      this.$emit('handleChange', this.selected)
    },
    changecClassType(type) {
      this.unfold()

      if (type === this.classType) {
        return
      }
      this.classType = type
      this.selected.V1 = ''
      this.selected.V2 = ''
      this.selected.V3 = ''
      this.selected.V4 = ''
      this.selected.V6 = ''
      this.majorClassList = []
      this.majorList = []
      this.selected.profession = [] // 清空专业分类
      this.selected.industryId = ''
      this.selected.deviceId = ''
      this.selected.industryAttr = [] // 清空行业分类
      this.selected.needArea = false
      this.selected.needStar = false
      this.$emit('handleChange', this.selected)
    },
    getMachineList() {
      machineList().then(res => {
        if (res.code === 200) {
          this.machineList = res.data.list
          this.machineList.unshift({
            id: '',
            name: this.$t('selection.all')
          })
          console.log('this.machineList', this.machineList)
        }
      })
    },
    setEnglishLabelStyle() {
      const selection = this.$refs.selection
      if (selection) {
        const labels = selection.querySelectorAll('.label')
        labels.forEach(label => {
          label.style.width = '120px' // 设置宽度
          label.style.textAlign = 'right' // 设置对齐方式
        })
        console.log('设置成功 ----->', )
      }
    },
  }
}
</script>

<style lang="less" scoped>
.selection {
  position: absolute;
  z-index: 99;
  width: 87%;
}
.filter {
  display: flex;
  align-items: flex-end;
  /deep/.ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    position: relative;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 69px;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      width: 100%;
      height: 35px;
      .ant-input {
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-radius: 20px;
        box-shadow: none;
        border: 1px solid #d8dce0;
        &:focus {
          border-color: #ffb829;
          box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
        }
      }
    }
    .ant-input-group-addon {
      position: absolute;
      right: 63px;
      top: 0;
      border-radius: 20px;
      z-index: 2;
      background: none;
      .search-btn {
        border-left: 0;
        height: 35px;
        border-color: rgba(0, 0, 0, 0);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: none;
        padding-right: 109px;
        &::after {
          content: none;
        }
        span {
          display: flex;
          font-size: 14px;
          color: #333333;
          position: relative;
          align-items: center;
          &::before {
            left: -8px;
            content: '';
            width: 1px;
            height: 15px;
            background: #e9e9e9;
            position: absolute;
          }
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
}
.flexEnd {
  justify-content: flex-end;
}
.between {
  justify-content: space-between;
}
.resourceType {
  display: flex;
  margin-top: 15px;
  align-items: center;
  flex-wrap: wrap;
  .label {
    font-size: 14px;
    font-weight: 400;
    color: #596777;
    line-height: 17px;
  }
  .list span {
    color: #000;
    display: flex;
    font-size: 14px;
    cursor: pointer;
    padding: 2px 10px 0px;
  }
}
.treeSelect {
  margin-right: 22px;
}
.auth {
  display: flex;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
  align-items: center;
  /deep/.ant-switch {
    width: 58px;
    height: 28px;
    background: #e0e6ea;
    &::after {
      width: 24px;
      height: 24px;
    }
  }
  /deep/.ant-switch.ant-switch-checked {
    background: #ff6d00;
  }
  .label {
    font-size: 14px;
    font-weight: 550;
    color: #000000;
    line-height: 20px;
    width: auto !important;
  }
}
.selected {
  font-weight: 550;
  color: #ff6d00 !important;
  position: relative;
  justify-content: center;
  // &::after {
  //   bottom: 0px;
  //   content: '';
  //   width: 23px;
  //   height: 4px;
  //   background: #ff6d00;
  //   border-radius: 3px;
  //   position: absolute;
  // }
}
/deep/ .ant-input-group:focus {
  border: 1px solid #3180ce;
}
.major-tree {
  position: relative;
  .resourceType {
    align-items: flex-start;
    margin-top: 6px;
    .label {
      // width: 60px;
      margin-top: 4px;
      text-align: right;
    }
    .group-list {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .list {
        span {
          margin-bottom: 7px;
        }
      }
    }
  }
  .majorSelector {
    // position: absolute;
    // z-index: 999;
    max-height: 550px; // 初始值
    overflow: hidden;
    padding-bottom: 30px;
    padding-left: 2%;
    padding-right: 30px;
    margin-left: -2%;
    // border: 1px solid #d8dce0;
    border-top: none;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background: rgba(255, 255, 255, 0.9);
    // top: 45px;
    // left: 0;
    width: 103.5%;
    // box-shadow: 0px 5px 7px -2px rgba(0, 0, 0, 0.1);
    transition: all 0.6s ease;
    .pack-up {
      position: absolute;
      bottom: 5px;
      left: 50%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #767d95;
      font-size: 12px;
      margin-bottom: 10px;
      &::after {
        content: '';
        width: 25px;
        height: 1px;
        background: #ccc;
        margin-left: 5px;
      }
      &::before {
        content: '';
        width: 25px;
        height: 1px;
        background: #ccc;
        margin-right: 5px;
      }
    }
    .resourceType {
      margin-top: 6px;
    }
  }
  .unfold {
    position: absolute;
    bottom: 0px;
    left: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #767d95;
    font-size: 12px;
    // margin-bottom: 10px;
    &::after {
      content: '';
      width: 25px;
      height: 1px;
      background: #ccc;
      margin-left: 5px;
    }
    &::before {
      content: '';
      width: 25px;
      height: 1px;
      background: #ccc;
      margin-right: 5px;
    }
  }
}
.mt0 {
  margin-top: 0 !important;
}
</style>
